/*
 * @Author: c.k
 * @Date: 2022-11-15 13:33:41
 * @LastEditors: c.k
 * @LastEditTime: 2023-03-06 14:31:32
 * @Descripttion:
 */

// import fs from 'fs-extra';
import { Message } from 'element-ui'
import Compressor from 'compressorjs'
import { commonsOssStsAPI } from '@/enum/api'
// export const multipartUploadBase64Fun = (imgBase64, targetId) => {
//     const _stsInfo = JSON.parse(window.localStorage.getItem('vuex')).ossToken
//     // 将 OSS 放到一个单例里面
//     let ossClient = new OSS({
//         region: _stsInfo.region,
//         accessKeyId: _stsInfo.accessKeyId,
//         accessKeySecret: _stsInfo.accessKeySecret,
//         bucket: _stsInfo.bucket,
//         endpoint: _stsInfo.endpoint,
//         stsToken: _stsInfo.stsToken,
//         secure: true
//     })
//     return new Promise((resolve, reject) => {
//         let arr = imgBase64.split(',')
//         if (arr.length < 2) {
//             Message.info('无效的图片')
//             return reject('无效的图片')
//         }
//         let mime = arr[0].match(/:(.*?);/)[1]
//         let bstr = atob(arr[1])
//         let n = bstr.length
//         let u8arr = new Uint8Array(n)
//         while (n--) {
//             u8arr[n] = bstr.charCodeAt(n)
//         }
//         let theBlob = new Blob([u8arr], { type: 'image/jpg' })
//         let tempTime = new Date()
//         theBlob.lastModifiedDate = tempTime
//         theBlob.name = `${'/im/' + parseTime(new Date(), '{y}{m}{d}')}/${random_string(10)}_${new Date().getTime()}.${theBlob.type.split('/')[1]}`
//         console.log('theBlob.name :>> ', theBlob)
//         let result = null
//         try {
//             ossClient
//                 .put(theBlob.name, theBlob, {
//                     ContentType: 'image/jpg'
//                 })
//                 .then((res) => {
//                     //
//                     resolve(res)
//                 })
//                 .catch((error) => {
//                     //
//                     reject(error)
//                 })
//             // result = ossClient.multipartUpload(`im/${img.name}`, img);
//         } catch (e) {
//             // 捕获超时异常
//             if (e.code === 'ConnectionTimeoutError') {
//                 console.log('Woops,超时啦!')
//                 // do ConnectionTimeoutError operation
//             }
//             reject(e)
//         }
//     })
// }

/***
 *  阿里的图片文件上传
 */
// function multipartUploadFileFun(img) {
//     const _stsInfo = JSON.parse(window.localStorage.getItem('stsInfo')) //  { ...storeInfo.getters.stsInfo };
//     // 将 OSS 放到一个单例里面
//     let ossClient = new OSS({
//         region: _stsInfo.regionId,
//         accessKeyId: _stsInfo.accessKeyId,
//         accessKeySecret: _stsInfo.accessKeySecret,
//         bucket: _stsInfo.bucketName,
//         endpoint: _stsInfo.endpoint,
//         stsToken: _stsInfo.securityToken,
//         secure: true
//     })
//     //
//     return new Promise((resolve, reject) => {
//         let result = null
//         try {
//             const fileName = `/im/${parseTime(new Date(), '{y}{m}{d}')}/${random_string(10)}`
//             ossClient
//                 .put(fileName, img, {
//                     ContentType: img.type
//                 })
//                 .then((res) => {
//                     //
//                     resolve(res)
//                 })
//                 .catch((error) => {
//                     //
//                     reject(error)
//                 })
//             // result = ossClient.multipartUpload(`im/${img.name}`, img);
//         } catch (e) {
//             // 捕获超时异常
//             if (e.code === 'ConnectionTimeoutError') {
//                 console.log('Woops,超时啦!')
//                 // do ConnectionTimeoutError operation
//             }
//             reject(e)
//         }
//     })
// }

// 图片上传前的校验
// export const beforeAvatarUploadFun = (file, _this) => {
//     const _stsInfo = JSON.parse(window.localStorage.getItem('stsInfo'))
//     const _result = limitImg(file)
//     if (_result) {
//         Promise.reject(new Error('fail'))
//     } else {
//         // return multipartUploadFileFun(file, _this.$store.state.user.stsInfo);
//         return multipartUploadFileFun(file, _stsInfo)
//     }
// }

// 图片格式的限制和尺寸大小的限制
// function limitImg(file) {
//     //
//     // 文件类型的 处理
//     let isLimitType = false
//     switch (file.type) {
//         case 'image/jpeg':
//             isLimitType = true
//             break
//         case 'image/jpg':
//             isLimitType = true
//             break
//         case 'image/png':
//             isLimitType = true
//         case 'image/gif':
//             isLimitType = true
//             break

//         default:
//             break
//     }
//     const isLt2M = file.size / 1024 / 1024 < 5

//     // 文件大小的处理

//     if (!isLimitType) {
//         Message.error('上传头像图片只能是 JPG,png,gif 格式!')
//         return true
//     }
//     if (!isLt2M) {
//         Message.error('上传头像图片大小不能超过 5MB!')
//         return true
//     }
//     return false
// }

import { UPLOAD_CONFIG } from '@/enum/uploadType'

/**
 * 上传文件
 * @param {string} fileName 文件名
 * @param {File} file 文件对象 自动判断文件类型
 * @param {object} option 上传配置、compress是否压缩
 * @returns {Promise<string>} 返回文件信息：url、name
 */

// OSS地址前缀
const ossDomains = {}
// oss客户端实例，目前分为私库和公库
const ossClient = {}
// 最大重试次数
const maxTryCount = 1
// 文件名称
let fileName = {}

function loadScript (src) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script')
        script.async = true
        script.src = src
        script.onerror = reject
        script.onload = resolve
        document.head.appendChild(script)
    })
}

export const ossUploadFile = async (uploadType, file, option = {}) => {
    if (file instanceof File) {
        file = [file]
    }
    fileName = {}
    if (!uploadType || !file) { return console.error('ossUploadFile=>缺少参数') }
    // 获取上传配置
    const { bucketType, bizType } = getUploadParams(uploadType)

    /** @首次上传先获取oss实例 **/
    await initOssClient(bucketType, bizType, file)
    const fileUrlList = []

    for (const [index, item] of fileName.name.entries()) {
        // 根据option.compress判断是否进行压缩
        if (option.compress && file[index].type.includes('image') && !file[index].type.includes('gif')) {
            file[index] = await compressFile(file[index])
        }
        let res
        let error
        let tryCount = 0
        while (tryCount <= maxTryCount) {
            try {
                res = await ossClient[bucketType].multipartUpload(item, file[index], {
                    headers: {
                        'Cache-Control': 'max-age=604800',
                        'x-oss-forbid-overwrite': true
                    },
                    ...option
                })
                error = null
                break
            } catch (err) {
                // 失败重试
                error = err
                tryCount++
                if (tryCount <= maxTryCount) { await initOssClient(bucketType, bizType, file) }
            }
        }

        // 发送错误
        if (!res || error) {
            Message.warning('文件发送出错, 请重试')
            console.error(error)
            return null
        }

        // 发送失败
        if (res.res.statusCode !== 200) {
            Message.warning('文件发送失败, 请重试')
            return null
        }
        fileUrlList.push({
            name: res.name,
            url: `${ossDomains[bucketType]}/${res.name}`,
            key: res.name
        })
    }
    // console.log(fileUrlList, ' fileUrlList')
    // 返回文件信息，包含name、url、key
    return fileUrlList.length > 1 ? fileUrlList : fileUrlList[0]
}

/**
 * 初始化OSS
 * @param {string} bucketType 类型
 */
async function initOssClient (bucketType, bizType, file) {
    // console.log(file, 'file1111')
    const fileNameList = []
    for (let i = 0; i < file.length; i++) {
        const item = file[i]
        fileNameList.push(item.name)
    }
    // console.log(fileNameList, 'fileNameList')

    const par = {
        bizType,
        objectNames: fileNameList
    }
    const res = await commonsOssStsAPI(par)
    if (!res.success) {
        Message.warning('上传失败')
        console.error(`initOssClient=>获取配置失败${JSON.stringify(res)}`)
        return
    }
    const config = {
        accessKeyId: res.data.accessKeyId,
        accessKeySecret: res.data.accessKeySecret,
        bucket: res.data.bucketName,
        region: res.data.regionId,
        endpoint: res.data.endpoint,
        stsToken: res.data.securityToken
    }
    fileName.name = res.data.objectList
    ossDomains[bucketType] = res.data.domain

    if (!window.OSS)
    { await loadScript('https://oss.pzds.com/aliyun-oss-sdk-6.21.0.min.js') }
    ossClient[bucketType] = new window.OSS(config)
    return ossClient
}

/**
 * 压缩文件
 * @param {File} file 文件
 */
function compressFile (file) {
    // console.log(file, 'file')
    return new Promise((resolve, reject) => {
        // eslint-disable-next-line no-unused-vars
        const compressor = new Compressor(file, {
            // 压缩质量, 0-1
            quality: 1,
            // 需要压缩的起始大小，默认5M, 5 * 1000 * 1000
            convertSize: 1000000,
            // 压缩成功后处理
            success (result) {
                resolve(result)
            },
            error (err) {
                // console.log(err.message)
                reject(new Error(err.message))
            }
        })
    })
}

/**
 * 根据uploadType获取具体上传配置信息，即根据/app/display/，获取bucket类型private/common生成fileName
 * @param {string} uploadType 场景
 */
// 即根据如/game/icon/，获取bucket类型private/common生成fileName
function getUploadParams (uploadType) {
    const uploadParams = {}

    // for (const bucketType in UPLOAD_CONFIG) {
    //     const params = UPLOAD_CONFIG[bucketType]
    //     if (Object.values(params.uploadTypes).includes(uploadType)) {
    //         Object.assign(uploadParams, { bucketType, ...params })
    //         break
    //     }
    // }

    for (const bucketType in UPLOAD_CONFIG) {
        const params = UPLOAD_CONFIG[bucketType]
        for (const type in params.uploadTypes) {
            if (params.uploadTypes[type].value === uploadType) {
                Object.assign(uploadParams, { bucketType, bizType: params.uploadTypes[type].key, ...params })
                break
            }
        }
    }

    return uploadParams // 包含fileName、bucketType
}
